import { useMutation, useQueryClient } from "react-query";
import {
  connectChowdeckProducts,
  connectChowdeckStore,
  deleteMarketplaceStoresMapping,
  updateConnectChowdeckProducts,
  updateStoreMappingSettings,
} from "../../../services/marketplace";

export const useDeleteChowdeckConnection = () => {
  const queryClient = useQueryClient();

  return useMutation((data) => deleteMarketplaceStoresMapping(data), {
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["storesMappingList"] });
    },
  });
};

export const useConnectChowdeckStore = ({
  queryParams = {},
  providerKey = "",
}) => {
  return useMutation((data) =>
    connectChowdeckStore({ data, queryParams, providerKey }),
  );
};

export const useConnectChowdeckProducts = ({ queryParams = {} }) => {
  const queryClient = useQueryClient();
  return useMutation((data) => connectChowdeckProducts({ data, queryParams }), {
    onSuccess: () => {
      queryClient.invalidateQueries(["getMappedUnmappedChowdeckProducts"]);
    },
  });
};

export const useUpdateConnectChowdeckProducts = ({ queryParams = {} }) => {
  const queryClient = useQueryClient();
  return useMutation(
    (data) => updateConnectChowdeckProducts({ data, queryParams }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["getMappedUnmappedChowdeckProducts"]);
        queryClient.invalidateQueries(["getStoreMappingDetails"]);
      },
    },
  );
};

export const useUpdateStoreMappingSettings = ({ id, queryParams = {} }) => {
  const queryClient = useQueryClient();
  return useMutation(
    (data) => updateStoreMappingSettings({ data, id, queryParams }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["getMappedUnmappedChowdeckProducts"]);
        queryClient.invalidateQueries(["getStoreMappingDetails"]);
      },
    },
  );
};
